import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import AccountUpdateDialog from "./AccountUpdateDialog";
import { setAccount } from "redux/ducks/accountSlice";
import { LoadingMgs } from "components/Common/toastify";
import { post } from "lib/requests";
import { SuccessMessage } from "components/Common/toastify";

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const AccountDetails = () => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const userDetails = useSelector((state) => state.user);
	const [customerData, setCustomerData] = useState(null);
	const customerDetails = useSelector((state) => state.customer);
	const [accountUpdateDialog, setAccountUpdateDialog] = useState(false);
	const [showHide, setShowHide] = useState(true);
	const [payWaySubscription, setPayWaySubscription] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		if (customerDetails?.tenantId) getCustomerData();
		return function cleanup() {};
	}, [customerDetails]);

	const getCustomerData = async () => {
		setLoading(true);

		try {
			await get(`/api/account/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						setCustomerData(res.data.records);
						dispatch(setAccount(res.data.records));
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Account Details", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Account Details", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Account Details", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	async function submitPayWay() {
		if (payWaySubscription) {
			return;
		}
		setPayWaySubscription(true);
		LoadingMgs("Resend Payway", "processing...");
		try {
			await post(
				`/api/customer/resendpayway/${customerDetails?.tenantId}`,
				{},
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Resend Payway", res.data.message);
					} else {
						ErrorMessage("Resend Payway", res.data.message);
					}
					setPayWaySubscription(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Resend Payway", message);
					setPayWaySubscription(false);
				});
		} catch (error) {
			ErrorMessage("Resend Payway", "Something went wrong try again!!");
			setLoading(false);
			setPayWaySubscription(false);
		}
	}

	return (
		<div className={classesCSStyles.mx5}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info" className={classesCSStyles.sectionHeader}>
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>Account Details</h4>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classesCSStyles.alignRight}>
							<div className={classesCSStyles?.editBtns}>
								{userDetails?.canaddeditdelete && (
									<div
										onClick={() => setAccountUpdateDialog(true)}
										className={classNames(classesCSStyles.editBtn)}>
										EDIT
									</div>
								)}
								<div
									onClick={() => {
										setShowHide(!showHide);
									}}
									className={classNames(classesCSStyles.editBtn)}>
									{showHide ? "HIDE" : "SHOW"}
								</div>
							</div>
						</GridItem>
					</GridContainer>
				</CardHeader>
				{showHide && (
					<div className={classesCSStyles?.customerListHeader}>
						{loading && (
							<Loading
								width={30}
								height={30}
								className={classNames(
									classesCSStyles?.absoluteLoading,
									classesCSStyles?.mT30
								)}
							/>
						)}

						{customerData && (
							<CardBody
								className={classNames(
									classesCSStyles.accountSection,
									classesCSStyles.my10
								)}>
								<GridContainer className={classNames(classesCSStyles.marginAuto)}>
									<GridItem xs={12} sm={3} md={3}>
										<div className={classesCSStyles?.mB}>
											<div className={classesCSStyles?.labelAc}>Microsoft Domain: </div>
											{customerData?.microsoft_domain || "-"}
										</div>
										<div className={classesCSStyles?.mB}>
											<div className={classesCSStyles?.labelAc}>Microsoft ID: </div>
											{customerData?.microsoft_id || "-"}
										</div>
									</GridItem>
									<GridItem xs={12} sm={4} md={4}>
										<div className={classNames(classesCSStyles?.labelAc)}>
											Agreement :
										</div>
										<div className={classesCSStyles?.py2}>
											Customer acceptance through Microsoft :{" "}
											<span>{customerData?.acceptance_microsoft || "-"}</span>
										</div>
										<div className={classesCSStyles?.py2}>
											Customer acceptance confirmed by partner :{" "}
											<span>{customerData?.acceptance_partner || "-"}</span>
										</div>
										<div className={classesCSStyles?.py2}>
											Direct Debit Agreement :{" "}
											<span>{customerData?.ddagreement || "-"}</span>
										</div>
										{customerData?.directcustomer && (
											<div className={classesCSStyles?.py2}>
												Signed on Payway :{" "}
												<span>{customerData?.payway == "no" ? "No" : "Yes"}</span>
												&nbsp;&nbsp;
												<button
													type="button"
													disabled={payWaySubscription}
													onClick={submitPayWay}
													className={classesCSStyles?.buttonPrimary}>
													Resend Payway
												</button>
											</div>
										)}
									</GridItem>
									<GridItem xs={12} sm={3} md={3}>
										<span className={classesCSStyles?.labelAc}>Company: </span>
										<div>{customerData?.company?.name || "-"} </div>
										<div>{customerData?.company?.address || "-"} </div>
										<div>
											{customerData?.company?.country || ""},
											{customerData?.company?.postalCode || ""},
											{customerData?.company?.city || ""}
										</div>
										<div></div>
									</GridItem>
									<GridItem xs={12} sm={2} md={2}>
										<span className={classesCSStyles?.labelAc}>Primary Contact: </span>
										<div>
											{customerData?.primarycontact?.firstName || "-"}{" "}
											{customerData?.primarycontact?.lastName || "-"}
										</div>
										<div>{customerData?.primarycontact?.email || "-"}</div>
										<div>{customerData?.primarycontact?.phone || "-"}</div>
									</GridItem>
								</GridContainer>
							</CardBody>
						)}
					</div>
				)}
			</Card>
			{accountUpdateDialog && (
				<AccountUpdateDialog
					accountUpdateDialog={accountUpdateDialog}
					setAccountUpdateDialog={setAccountUpdateDialog}
				/>
			)}
		</div>
	);
};

export default AccountDetails;
